import { downloadExcel } from 'react-export-table-to-excel';
import moment from 'moment';

export const handleDownloadExcel =(header, body)=> {
    downloadExcel({
      fileName: `Weekly_Plan_Report_${moment().format('DD-MM-YYYY_HH-mm-ss') }`,
      sheet: "react-export-table-to-excel",
      tablePayload: {
        header,
        // accept two different data structures
        body
      },
    });
  }